"use server";
async function r({ story: e, pathToRevalidate: i }) {
  if (!e || !i)
    return console.error("liveEditUpdateAction: story or pathToRevalidate is not provided");
  if (globalThis.storyCache.set(e.uuid, e), process.env.NEXT_RUNTIME)
    try {
      const { revalidatePath: t } = await import("next/cache");
      t(i);
    } catch (t) {
      console.error("liveEditUpdateAction: error while revalidating path", t);
    }
}
export {
  r as liveEditUpdateAction
};
